export const HYRO_BUTTON_GROUP_TEST_ID = "hyro-button-group";

export const hyroButtonGroupOptionTestId = (option, selected) => `hyro-button-${option}${selected ? "-selected" : ""}`;
